import { useLayoutEffect } from "react";
import { useLocation } from "react-router";

// ルート遷移のたびに画面最上部へスクロールを戻す。全ページが AppLayout 配下の
// 単一ルートツリーにあり、スクロールは window 上で発生するため、ルーター直下に
// 常駐するこのコンポーネント 1 つで全遷移をカバーできる。UI は描画しない。
export function ScrollToTop() {
  const { pathname } = useLocation();

  // ブラウザ既定 (scrollRestoration=auto) だとバック時に前回位置が復元されるため、
  // manual に切り替えて遷移方向 (PUSH / POP) に依らず常に先頭表示にする。
  // 元値を退避し、アンマウント時に復元して他挙動への副作用を残さない。
  useLayoutEffect(() => {
    if (!("scrollRestoration" in window.history)) return;
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => {
      window.history.scrollRestoration = previous;
    };
  }, []);

  // 描画前 (useLayoutEffect) に先頭へ戻し、前画面位置のちらつきを防ぐ。
  // pathname はスクロールリセットの再実行トリガーとして依存に含める (本体では未参照)。
  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname は再実行トリガーとして意図的に指定している
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
